let _dashboardMagicLink: string | null = null;

export function setTransientDashboardMagicLink(link: string): void {
  _dashboardMagicLink = link;
}

export function consumeTransientDashboardMagicLink(): string | null {
  const link = _dashboardMagicLink;
  _dashboardMagicLink = null;
  return link;
}
